import pegasus from "../../assets/scripts/global/01-pegasus";

document.addEventListener("alpine:init", () => {
    Alpine.data("navigation", () => ({
        scrolled: false,
        visible: true,
        mobMenuOpen: false,
        mobSubMenuOpen: false,
        lastScrollTop: 0,
        open: null,
        submenu: null,
        mobSubMenu: null,
        megamenu: null,
        currentItem: null,
        isMobile: true,
        loaded: false,
        hasTransparentBg: false,
        menuOpen: false,
        containers: null,
        init() {
            this.hasTransparentBg = this.$refs.navBar.classList.contains(
                "bg-navbar-transparent"
            );

            pegasus.onResizeFinished(() => {
                this.isMobile = window.outerWidth <= 1095;

                const page = document.getElementById("content");

                if (this.hasTransparentBg === false) {
                    if (this.isMobile) {
                        page.style.paddingTop = "60px";
                    } else {
                        page.style.paddingTop = "81px";
                    }
                }
            }, true);
        },
        lockScroll() {
            document.getElementsByTagName("body")[0].style.overflow = "hidden";
        },
        unlockScroll() {
            document.getElementsByTagName("body")[0].style.overflow = "auto";
        },
        menuScrolling() {
            const navigationContainer =
                    document.getElementById("page-nav-container"),
                navigationHeight = navigationContainer.offsetHeight;

            this.scrolled = window.scrollY >= navigationHeight;

            let st = window.scrollY;

            if (st >= this.lastScrollTop) {
                //Scroll Down
                if (st >= navigationHeight) {
                    navigationContainer.classList.add("-translate-y-full");
                    this.visible = false;
                } else {
                    navigationContainer.classList.remove("-translate-y-full");
                    this.visible = true;
                }
            } else {
                //Scroll Up
                navigationContainer.classList.remove("-translate-y-full");
                this.visible = true;
            }

            this.lastScrollTop = st;

            this.hasTransparentBg = this.$refs.navBar.classList.contains(
                "bg-navbar-transparent"
            );
        },
        toggleOpen(menuID) {
            this.sub_nav = [];
            if (this.open !== menuID) {
                this.open = menuID;
            } else {
                this.open = null;
            }
        },
        navZedTop() {
            document.getElementById("page-header").classList.toggle("z-[5000]");
            document.getElementById("page-header").classList.toggle("z-[9999]");
        },
        openNav() {
            this.navZedTop();
            this.menuOpen = true;
            this.lockScroll();
        },
        closeNav() {
            this.open = null;
            this.submenu = null;
            this.megamenu = null;
            this.menuOpen = false;
            this.unlockScroll();
            setTimeout(this.navZedTop, 150);
        },
        handleOpenNav() {
            this.openNav();
        },
        toggleMenu(subNavId) {
            let i = this.sub_nav.indexOf(subNavId);
            if (i === -1) {
                this.sub_nav.push(subNavId);
            } else {
                this.sub_nav.splice(i, 1);
            }
        },
        toggleSubMenu(subNavId) {
            return this.sub_nav.includes(subNavId);
        },
    }));
});
